var React = require('react');

function HeroWave (props) {
    return React.createElement("svg",props,[React.createElement("title",{"id":"title","key":0},"wave"),React.createElement("g",{"key":1},React.createElement("path",{"d":"M1920,14.5V110H0V44.5c196-36,452.1-15.7,657.5,8.5C887.2,80.1,1527.5,110,1920,14.5z"}))]);
}

HeroWave.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 1920 110","style":{"enableBackground":"new 0 0 1920 110"},"xmlSpace":"preserve"};

module.exports = HeroWave;

HeroWave.default = HeroWave;
